import { FeatureFlag } from '@backstage/core-plugin-api';
import {
  FEATURE_FLAG_ORG_WIDE_RANKING_CHARTS,
  PROD_DEV_DASHBOARD_QUALITY_POSTURE,
} from '@appfolio/backstage-plugin-metrics-common';
import { metricsPlugin } from '@appfolio/backstage-plugin-metrics';
import { FEATURE_FLAG_SHOW_CREATE_BUTTON } from '@appfolio/backstage-plugin-navigation-common';

const featureFlags: FeatureFlag[] = [
  {
    pluginId: metricsPlugin.getId(),
    name: FEATURE_FLAG_ORG_WIDE_RANKING_CHARTS,
    description:
      'Enables organization-wide team ranking charts for all metrics',
  },
  {
    pluginId: metricsPlugin.getId(),
    name: PROD_DEV_DASHBOARD_QUALITY_POSTURE,
    description: 'Enables additional metrics in the quality metric view',
  },
  {
    pluginId: '',
    name: FEATURE_FLAG_SHOW_CREATE_BUTTON,
    description: 'Shows the Create button in the sidebar navigation',
  },
];

export default featureFlags;
